import { addHours } from 'date-fns'
import { createStore } from 'jotai'

import {
  DesktopAppDetectionBannerState,
  desktopAppDetectionBannerStateAtom,
  DesktopAppMode,
  getDesktopAppMode,
} from './desktopAppDetectionBannerLogicState'

export type JotaiStore = ReturnType<typeof createStore>
const COOLDOWN_HOURS = 3

export function isWithinCooldownPeriod(
  currentState: DesktopAppDetectionBannerState,
): boolean {
  const lastDismiss = currentState.lastDismissDate
    ? new Date(currentState.lastDismissDate)
    : null

  if (!lastDismiss) return false

  return addHours(lastDismiss, COOLDOWN_HOURS) > new Date()
}

export function shouldShowDesktopAppBanner(
  state: DesktopAppDetectionBannerState,
): boolean {
  return (
    getDesktopAppMode(state) === DesktopAppMode.Ask &&
    !isWithinCooldownPeriod(state)
  )
}

/** Stores `mode` and drops the legacy flag and any banner cooldown. */
export const toDesktopAppModeState = (
  mode: DesktopAppMode,
): DesktopAppDetectionBannerState => ({ mode })

export function handleIgnoreAction(store: JotaiStore) {
  store.set(
    desktopAppDetectionBannerStateAtom,
    toDesktopAppModeState(DesktopAppMode.Never),
  )
}

export function handleDismissAction(store: JotaiStore) {
  store.set(desktopAppDetectionBannerStateAtom, (prev) => ({
    ...prev,
    lastDismissDate: new Date().toISOString(),
  }))
}

export function handleDownloadNavigation(store: JotaiStore) {
  store.set(desktopAppDetectionBannerStateAtom, (prev) => ({
    ...prev,
    lastDismissDate: new Date().toISOString(),
  }))
}
